import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wo-table-actions',
  templateUrl: './table-actions.component.html',
  styleUrls: [ './table-actions.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionsComponent {}
